import React from 'react';
import { Loader } from '@fiverr-private/feedback';
import { Typography } from '@fiverr-private/typography';
import { CheckIcon } from '@fiverr-private/visuals';
import { Container } from '@fiverr-private/layout_components';
import { appTranslate } from '../../i18n';
import { useResendEmailWithCode } from './hooks/useResendEmailWithCode';

interface ResendProps {
    email: string;
    showResendSuccess: boolean;
    setShowResendSuccess: React.Dispatch<React.SetStateAction<boolean>>;
}

const Resend = ({ email, setShowResendSuccess, showResendSuccess }: ResendProps) => {
    const { isResending, resend } = useResendEmailWithCode({
        email,
        setShowResendSuccess,
    });

    return showResendSuccess ? (
        <Container display="flex">
            <Container>
                <CheckIcon />
            </Container>
            <Typography size="b_sm" fontWeight="semibold" color="grey_1100" as="span" marginLeft="2">
                {appTranslate<string>('activation.resend_code_success')}
            </Typography>
        </Container>
    ) : (
        <Container display="flex">
            {isResending && (
                <Container marginRight="2" marginTop="0.5">
                    <Loader size="sm" />
                </Container>
            )}
            <Typography
                as="span"
                size="b_sm"
                cursor="pointer"
                color="grey_1100"
                lineHeight="b_md"
                decoration="underline"
                fontWeight="semibold"
                onClick={resend}
            >
                {appTranslate<string>('activation.resend_code')}
            </Typography>
        </Container>
    );
};

export default Resend;
